import React from 'react'
import { Player } from '@lottiefiles/react-lottie-player'
import { loadingAnimationLottie } from './loadingAnimationData'

/** Above nested VaulDrawer (10001) in BottomSheetContext. */
const GLOBAL_OVERLAY_LOADING_Z_INDEX = 10002

const ThreeLineLoading: React.FC = () => {
  return (
    <div
      className='fixed inset-0 flex items-center justify-center bg-black/50 h-screen w-screen'
      style={{ zIndex: GLOBAL_OVERLAY_LOADING_Z_INDEX }}
    >
      <div className='bg-white/85 rounded-xl shadow-2xl p-3'>
        <Player autoplay loop src={loadingAnimationLottie} style={{ width: '42px', height: '42px' }} />
      </div>
    </div>
  )
}

export default ThreeLineLoading
